import { render } from "./MenuSimple.vue?vue&type=template&id=a996f8a6&scoped=true"
import script from "./MenuSimple.vue?vue&type=script&lang=js"
export * from "./MenuSimple.vue?vue&type=script&lang=js"

import "./MenuSimple.vue?vue&type=style&index=0&id=a996f8a6&scoped=true&lang=css"

import exportComponent from "/home/kitrin/builds/isoevolve/20261004-205117/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a996f8a6"]])

export default __exports__